import React, { createContext, useContext, useState, useCallback } from 'react';

// Create the context
const ViewContext = createContext();

// Custom hook to use the context
export const useViewContext = () => {
  const context = useContext(ViewContext);
  if (!context) {
    throw new Error('useViewContext must be used within a ViewProvider');
  }
  return context;
};

// Context provider component
export const ViewProvider = ({ children }) => {
  // State for the current view
  const [currentView, setCurrentView] = useState('dashboard');

  // Action to set the view
  const setView = useCallback((view) => {
    setCurrentView(view);
  }, []);

  const value = {
    currentView,
    setView,
  };

  return (
    <ViewContext.Provider value={value}>
      {children}
    </ViewContext.Provider>
  );
};

export default ViewContext;
